var map = {
	"./1.jpg": 13150,
	"./IMG_0940.JPG": 66724,
	"./IMG_0941.JPG": 40097,
	"./IMG_0942.JPG": 46571,
	"./IMG_0943.JPG": 5005,
	"./IMG_0944.JPG": 20079,
	"./IMG_0945.JPG": 72758,
	"./IMG_0947.JPG": 57904,
	"./IMG_0948.JPG": 23337,
	"./IMG_0949.JPG": 67040,
	"./IMG_0950.JPG": 63733,
	"./IMG_0951.JPG": 31016,
	"./IMG_0952.JPG": 65886
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65962;